export default class EventCreateRequest {
    constructor(supportedLocales, dateForm) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: '&nbsp',
            };
        });
        this.id = null;
        this.start = dateForm;
        this.end = null;
        this.description = null;
        this.title = null;
        this.background = {value: "#808080"};
        this.longitude = null;
        this.latitude = null;
        this.localizationTolerance = null;
        this.status = null;
        this.createDate = null;
        this.participants = [];
        this.creator = null;
        this.dateRange = null;
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
            to.title = from.title;
        } else {
            to = new EventCreateRequest();
        }
    }

    static copy(from) {
        const to = new EventCreateRequest();
        EventCreateRequest.assign(from, to);
        return to;
    }
}
